import React, { useState, useEffect } from 'react';
import { fetchCountryData, fetchStatesDataOfIndia, setCountryName } from '../actions/action';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';


function Dashboard() {

	const dispatch = useDispatch();
	const currentCountry = useSelector(state => state.currentCountry);
	const currentCountryData = useSelector(state => state.currentCountryData);
  const indiaStatesData =  useSelector(state => state.indiaStatesData);
  const [searchText, setSearchText] = useState('');

	// useEffect(() => {
	// 	dispatch(fetchCountryData(currentCountry));
	// 	dispatch(fetchStatesDataOfIndia());
  // })

  dispatch(fetchCountryData(currentCountry));
	dispatch(fetchStatesDataOfIndia());
  
  const handleSearch = (e) => {
    e.preventDefault();
    console.log("check",e.target.value, e.key)
    setSearchText(e.target.value);
  }

  const handleKeyPress = (e) => {
    console.log(e.key, "check2")
    if(e.key === 'Enter') {
      console.log("check3", searchText)
      dispatch(setCountryName(searchText));
      dispatch(fetchCountryData(currentCountry));
    }
  }

  const setRoute = (state) => {
    if(state.includes(" ")) {
      let route = state.split(" ").join("-");
      return `/state/${route}`
    } else {
      return `/state/${state}`
    }
  }


  return (
    <div>
			<header className="center">
				<p className="text">Search By Country Name</p>
				<div className="container">
    			<input type="text" placeholder="Search by country..." value={searchText} onKeyPress={handleKeyPress} onChange={handleSearch} className="searchbar" />
  				<img src="https://images-na.ssl-images-amazon.com/images/I/41gYkruZM2L.png" alt="Magnifying Glass" className="button" />
  			</div>
			</header>
			<main>
				{
					(currentCountryData) ?
					<div>
						<p className="center sub-title">{currentCountryData.country} NovelCOVID-19 Status</p>
						{
							(currentCountry === 'india') ?
							<p className="center" style={{marginTop: '5px'}}> ( Last Update: { indiaStatesData.length && indiaStatesData[0].lastupdatedtime} )</p> : '' 
						}
            <div className="d-f fw-w center">
              <div className="main-card b-blue">
                <p style={{color: '#6980ff', fontWeight: 600}}>Confirmed</p>
                <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.1rem'}}>{indiaStatesData.length && indiaStatesData[0].confirmed}</p>
              </div>
              <div className="main-card b-yellow">
                <p style={{color: 'rgb(192, 174, 12)', fontWeight: 600}}>Active</p>
                <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.2rem'}}>{indiaStatesData.length && indiaStatesData[0].active}</p>
              </div>
              <div className="main-card b-green">
                <p style={{color: 'rgba(70, 194, 16, 0.93)', fontWeight: 600}}>Recovered</p>
                <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.1rem'}}>{indiaStatesData.length && indiaStatesData[0].recovered}</p>
              </div>
              <div className="main-card b-red">
                <p style={{color: 'rgba(199, 14, 14, 0.883)', fontWeight: 600}}>Deaths</p>
                <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.1rem'}}>{indiaStatesData.length && indiaStatesData[0].deaths}</p>
              </div>
              <div className="main-card b-sblue">
                <p style={{color: '#1db7bc', fontWeight: 600}}>Critical</p>
                <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.1rem'}}>{currentCountryData.critical}</p>
              </div>
						</div>

            <div>
              <p className="center" style={{marginTop: '30px', marginBottom: '10px'}}>See All India status by State: -</p>
              <ul>
                {
                  indiaStatesData.map((obj, idx) => {
                    return ((idx === 0) ? 
                    <li key={idx} className="list-item">State
                      <span>
                        <span style={{color: '#6980ff', fontWeight: 600, marginRight: '15px'}}>Confirmed</span>
                        <span style={{color: 'rgb(192, 174, 12)', fontWeight: 600, marginRight: '15px'}}>Active</span>
                        <span style={{width: '20px'}}></span>
                      </span>
                    </li> 
                    : <li key={idx}>
                      <Link to={setRoute(obj.state)} className="list-item">
                        {obj.state} 
                        <span>
                          <span style={{color: '#6980ff', fontWeight: 600, marginRight: '25px'}}>{obj.confirmed}</span>
                          <span style={{color: 'rgb(192, 174, 12)', fontWeight: 600, marginRight: '15px'}}>{obj.active}</span>
                          <img className="arrow" src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgNDUxLjg0NiA0NTEuODQ3IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NTEuODQ2IDQ1MS44NDc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNMzQ1LjQ0MSwyNDguMjkyTDE1MS4xNTQsNDQyLjU3M2MtMTIuMzU5LDEyLjM2NS0zMi4zOTcsMTIuMzY1LTQ0Ljc1LDBjLTEyLjM1NC0xMi4zNTQtMTIuMzU0LTMyLjM5MSwwLTQ0Ljc0NCAgIEwyNzguMzE4LDIyNS45MkwxMDYuNDA5LDU0LjAxN2MtMTIuMzU0LTEyLjM1OS0xMi4zNTQtMzIuMzk0LDAtNDQuNzQ4YzEyLjM1NC0xMi4zNTksMzIuMzkxLTEyLjM1OSw0NC43NSwwbDE5NC4yODcsMTk0LjI4NCAgIGM2LjE3Nyw2LjE4LDkuMjYyLDE0LjI3MSw5LjI2MiwyMi4zNjZDMzU0LjcwOCwyMzQuMDE4LDM1MS42MTcsMjQyLjExNSwzNDUuNDQxLDI0OC4yOTJ6IiBmaWxsPSIjMDAwMDAwIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==" />
                        </span>
                      </Link>
                    </li>)
                  })
                }
              </ul>
            </div>
					</div> : <div className="center mt-20"><div className="lds-dual-ring"></div></div>
				}
			</main>
		</div>
  );
}

export default Dashboard;
